@if (isMenu) {
  <button mat-menu-item aria-label="Reassign">
    <mat-icon>forward_to_inbox</mat-icon>
    {{ 'reassign' | translate }}
  </button>
} @else {
  <button
    mat-icon-button
    [attr.aria-label]="'reassign' | translate"
    matTooltip="{{ 'reassign' | translate }}">
    <mat-icon>forward_to_inbox</mat-icon>
  </button>
}
